import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';
import { SmallUnitRequest } from 'src/app/front-user/services/small-units/shared/models/Small-Unit-Request.model';
import { SmallUnitsServiceFE } from 'src/app/front-user/services/small-units/shared/services/small-units.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { FormMode, Languages, ServiceStatus, SUConfirmArrival } from 'src/app/shared/models/enums.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { MeasurementEstimateFeesComponent } from '../measurement-Estimate-fees/measurement-Estimate-fees-component';
import { SmallUnitadminDTO } from '../shared/models/small-units-admin.model';
import { SmallUnitsAdminService } from '../shared/services/small-units.service.admin';


@Component({
  selector: 'app-confirm-payment',
  templateUrl: './confirm-payment-component.html'
})

export class ConfirmPaymentComponent implements OnInit {
  submitted = false;
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest //= new BaseRequest();
  IsPaymentConfirmed = SUConfirmArrival;
  decisionKeys = Object.keys(this.IsPaymentConfirmed);
  decisionValue: number;
  displayedLang: string;
  public ConfimPaymentForm: FormGroup;
  user: User = new User();
  showRequest = false;
  treasuryConfirmPaymentObject: SmallUnitadminDTO = new SmallUnitadminDTO();
  smallUnitRequestDTO: SmallUnitRequest = new SmallUnitRequest();
  agentId: string;
  responseObj: ResponseObject = new ResponseObject();
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  numberRegex: string = '^[0-9]+(\\.?[0-9]+)?$';
  @Input() public isShow: boolean = true;
  @ViewChild('MeasurementEstimateFeesComponent',{static: false}) MeasurementEstimateFeesComponent: MeasurementEstimateFeesComponent;
  public disableForm: boolean = false;
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean = false;
  IsConfirmed: boolean = true;
  constructor(private formBuilder: FormBuilder,
    private globalSrv: GlobalServices,
    private route: ActivatedRoute, private router: Router,
    private authenticationService: AuthenticationService, private alertService: AlertService,
    private translate: TranslateService,
    private suServ: SmallUnitsServiceFE, private suAdminServ: SmallUnitsAdminService) {
    this.isShow = true;
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    } else {
      window.history.back();
    }
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    this.user = this.globalSrv.user;

  }

  ngOnInit(): void {
    this.buildForm();
  }
  buildForm() {
    this.ConfimPaymentForm = this.formBuilder.group({
      IsPaymentConfirmed: ['', [Validators.required]],
      Swift: ['', [Validators.required]],
    });
  }
  get f() {
    return this.ConfimPaymentForm.controls;
  }
  getBaseRequest() {
    this.suServ.get(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {

          this.smallUnitRequestDTO = this.responseObj.Data;
          this.requestStatus = this.smallUnitRequestDTO.StatusId;
          this.agentId = this.smallUnitRequestDTO.RequestorId;
          // check if component open fron request history
          if (history.state.data && history.state.data.isCompleted) {

            this.formMode = FormMode.Readonly;
            //to view "more information" data in case Measurement officer require it from agent and penending agent update
            //or after agent update request and pending Measurement officer approval

            this.buildForm();
            this.ConfimPaymentForm.patchValue({
              IsPaymentConfirmed: true,
              Swift: this.smallUnitRequestDTO.Swift,
            });
            this.ConfimPaymentForm.disable();
            // this.disableForm=true;
            this.IsConfirmed = false;
          } else if (this.requestStatus == ServiceStatus.SmallUnit_PendingMeasuringUnit || this.requestStatus == ServiceStatus.SmallUnit_PendingTreasuryOfficer) {
            this.formMode = FormMode.Add;
            this.ConfimPaymentForm.enable();
          } else {
            // to hide submit button
            this.formMode = FormMode.Readonly;
            this.ConfimPaymentForm.disable();
            this.IsConfirmed = false;
            this.ConfimPaymentForm.patchValue({
              IsPaymentConfirmed: true,
              Swift: this.smallUnitRequestDTO.Swift,
            });
          }

        }
      }

    )
  }
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.ConfimPaymentForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.treasuryConfirmPaymentObject = this.ConfimPaymentForm.value;
    this.treasuryConfirmPaymentObject.AdminEmail = this.user.UserName;
    this.treasuryConfirmPaymentObject.Id = this.baseRequestId;
    this.suAdminServ.ConfirmPayment(this.treasuryConfirmPaymentObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.ConfimPaymentForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }

        });
  }

}
